import { EVENT_PAGE_SLUGS } from '@apps/guest/shared/constants/eventPageSlugs';

// Guest owns the canonical slug values; re-exported here so all admin imports are unchanged.
// const + type with the same name mirrors the enum's dual value/type behavior.
export const EventPageSlugs = EVENT_PAGE_SLUGS;
export type EventPageSlugs = (typeof EVENT_PAGE_SLUGS)[keyof typeof EVENT_PAGE_SLUGS];
